<template>
  <v-card flat>
    <v-card class="pa-4" flat>
      <BusDocuments />
    </v-card>
    <v-card>
      <!-- <v-card-title>
        <v-row class="ms-1 mt-1 mb-3">
          <v-btn
            depressed
            small
            color="primary"
            class="me-3"
            @click="openPersonalDialog()"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>Add
            Personal</v-btn
          >
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" depressed small color="primary">
                <v-icon small>mdi-content-save-plus-outline</v-icon> Add
                ShareHolders
              </v-btn>
            </template>
            <v-list>
              <v-list-item color="primary" class="my-0">
                <v-btn small @click="openIndShareHolderDialog()" color="primary"
                  ><v-icon small>mdi-plus-outline</v-icon> Individual</v-btn
                >
              </v-list-item>
              <v-list-item @click="onClick">
                <v-btn small @click="openBUSShareHolderDialog()" color="primary"
                  ><v-icon small>mdi-plus-outline</v-icon> Business</v-btn
                >
              </v-list-item>
            </v-list>
          </v-menu>
        
        </v-row>
      </v-card-title> -->
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="getinformation"
        :search="search"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:item.id_type="{ item }">
          <span>{{ item.id_type ? item.id_type.value : null }}</span>
        </template>
        <template v-slot:item.occupation="{ item }">
          <span>{{ item.occupation ? item.occupation.value : null }}</span>
        </template>
        <template v-slot:item.nature_of_business="{ item }">
          <span>{{
            item.nature_of_business ? item.nature_of_business.value : null
          }}</span>
        </template>
        <template v-slot:item.nationality="{ item }">
          <span>{{
            item.nationality ? item.nationality.nationality : null
          }}</span>
        </template>
        <template v-slot:item.id_first_page="{ item }">
          <v-avatar
            v-if="item.id_first_page"
            size="36px"
            @click="handleImageViewer(item.id_first_page)"
          >
            <img
              v-if="item.id_first_page"
              alt="Avatar"
              :src="item.id_first_page"
            />
            <v-icon v-else>mdi-user</v-icon>
          </v-avatar>
          <v-avatar v-else color="gray" size="24px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <img
                  v-bind="attrs"
                  v-on="on"
                  alt="Avatar"
                  :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
                />
              </template>
              <span>No Image</span>
            </v-tooltip>
          </v-avatar>
        </template>
        <template v-slot:item.id_last_page="{ item }">
          <v-avatar
            v-if="item.id_last_page"
            size="36px"
            @click="handleImageViewer(item.id_last_page)"
          >
            <img
              v-if="item.id_last_page"
              alt="Avatar"
              :src="item.id_last_page"
            />
            <v-icon v-else>mdi-user</v-icon>
          </v-avatar>
          <v-avatar v-else color="gray" size="24px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <img
                  v-bind="attrs"
                  v-on="on"
                  alt="Avatar"
                  :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
                />
              </template>
              <span>No Image</span>
            </v-tooltip>
          </v-avatar>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            tittle="Edit"
            color="primary"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <!-- <v-icon small @click="deleteItem(item)" color="primary"> mdi-trash-can-outline </v-icon> -->
        </template>
      </v-data-table>
      <image-viewer
        :showDialog="isImageViewer"
        :picture="{
          PicHeight: '435',
          PicWidth: 600,
          Pic: imageViewerUrl,
        }"
        @closeImageViewer="handleCloseImageViewer"
      ></image-viewer>
    </v-card>
    <OverlayPageVue :showOverlay="loader" />
    <!-- business dialog -->
    <v-dialog persistent v-model="dialog" max-width="1000">
      <v-card>
        <v-form ref="Addform" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            Business ShareHolder
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Company Name
                </label>
                <v-text-field
                  v-model="editedItems.full_name"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Company Name"
                  :rules="FieldRequired(' Company Name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Registration No
                </label>
                <v-text-field
                  class="rounded"
                  v-model="editedItems.id_number"
                  dense
                  outlined
                  placeholder="Registration Number"
                  :rules="FieldRequired('Registration Number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Date of Incorporation
                </label>
                <v-text-field
                  v-model="editedItems.dob"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Date of Birth')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Nature Of Business
                </label>
                <v-autocomplete
                  :items="NatureOfBusiness"
                  v-model="editedItems.nature_of_business"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Nature Of Business"
                  :rules="FieldRequired('Nature Of Business')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Contact Number
                </label>
                <vue-phone-number-input
                  :default-country-code="company_mobile_cty_code"
                  v-model="editedItems.phone_number"
                  @input="onChangeCompanyNumber(editedItems.phone_number)"
                  class=""
                  required
                />
                <small v-if="contact_error2" class="danger"
                  >Contact number is required</small
                >
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  E-mail
                </label>
                <v-text-field
                  v-model="editedItems.email_id"
                  class="rounded"
                  dense
                  outlined
                  placeholder="E-mail"
                  :rules="FieldRequired('E-mail')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Country </label>
                <v-autocomplete
                  :items="CountryOptions"
                  v-model="editedItems.country_code"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Address </label>
                <v-text-field
                  v-model="editedItems.address"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Corporate Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  No of Shares
                </label>
                <v-text-field
                  v-model="editedItems.no_of_shares"
                  class="rounded"
                  dense
                  outlined
                  placeholder="No Of Shares"
                  :rules="FieldRequired('  No Of Shares')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Share Percentage
                </label>
                <v-text-field
                  v-model="editedItems.share_holding_percentage"
                  class="rounded"
                  dense
                  outlined
                  placeholder="Percentage"
                  :rules="FieldRequired('Percentage')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-col>

              <div
                class="col-md-12"
                style="display: flex; justify-content: right; margin-top: 8px"
              >
                <v-btn
                  depressed
                  color="primary"
                  min-width="170px"
                  class="me-5 text-capitalize"
                  @click="onSubmitFor()"
                >
                  Save
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  outlined
                  min-width="170px"
                  @click="closeDialog()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- individual dialog -->
    <v-dialog persistent v-model="indDialog" max-width="1000">
      <v-card>
        <v-form ref="IndForm" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            Individual ShareHolder
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closeIndDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Full Name
                </label>
                <v-text-field
                  v-model="editedItems.full_name"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Full Name"
                  :rules="FieldRequired(' Full Name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Gender
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Gender"
                  :rules="FieldRequired('Gender')"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Date of Birth
                </label>
                <v-text-field
                  v-model="editedItems.dob"
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Date of Birth')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Country Of Birth
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  :rules="FieldRequired('Country')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Nationality
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Nationality"
                  :rules="FieldRequired('Nationality')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Occupation
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Occupation"
                  :rules="FieldRequired('Occupation')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  E-mail
                </label>
                <v-text-field
                  v-model="editedItems.email_id"
                  class="rounded"
                  dense
                  outlined
                  placeholder="E-mail"
                  :rules="FieldRequired('E-mail')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize"> Address </label>
                <v-text-field
                  v-model="editedItems.address"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Contact Number
                </label>
                <vue-phone-number-input
                  :default-country-code="company_mobile_cty_code"
                  v-model="editedItems.phone_number"
                  @input="onChangeCompanyNumber(editedItems.phone_number)"
                  class=""
                  required
                />
                <small v-if="contact_error2" class="danger"
                  >Contact number is required</small
                >
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize">
                  Employer Name
                </label>
                <v-text-field
                  v-model="editedItems.address"
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Employer Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  ShareHolding(%)
                </label>
                <v-text-field
                  v-model="editedItems.share_holding_percentage"
                  class="rounded"
                  dense
                  outlined
                  placeholder="ShareHolding"
                  :rules="FieldRequired('ShareHolding')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  No of Shares
                </label>
                <v-text-field
                  v-model="editedItems.no_of_shares"
                  class="rounded"
                  dense
                  outlined
                  placeholder="No Of Shares"
                  :rules="FieldRequired('  No Of Shares')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  ID Type
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="ID Type"
                  :rules="FieldRequired('ID Type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Issue Date
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Issue Date')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Issue Location
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Issue Location "
                  :rules="FieldRequired('Issue Location ')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  Expiry Date
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Expiry Date')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <label class="my-0 rounded labelFontsize required">
                  ID Number
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="ID Number"
                  :rules="FieldRequired('ID Number')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0 required"
                  >ID First Page (Image only)
                </label>
                <v-file-input
                  dense
                  outlined
                  ref="partnerlogo"
                  class="rounded"
                  accept="image/png, image/jpeg, image/bmp, image/bmp"
                  placeholder="ID First Page"
                  prepend-icon=""
                  :rules="fileRules"
                >
                  <template v-slot:append>
                    <v-btn depressed x-small icon @click="openIdlast">
                      <v-icon aria-hidden="false" color="primary">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </template>
                  <!-- <template v-slot:append-outer>
                    <v-img
                      v-if="
                        partnerDetails.partner_Logo
                          ? partnerDetails.partner_Logo.value
                          : null
                      "
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                      :src="
                        partnerDetails.partner_Logo
                          ? partnerDetails.partner_Logo.value
                          : null
                      "
                      @click="
                        handleImageViewer(
                          partnerDetails.partner_Logo
                            ? partnerDetails.partner_Logo.value
                            : null
                        )
                      "
                    />
                  </template> -->
                  <!-- <template v-slot:append-outer>
                    <v-img
                      v-if="uploadedImage"
                      :src="uploadedImage"
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                    />
                  </template> -->
                </v-file-input>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0 required"
                  >ID Last Page (Image only)
                </label>
                <v-file-input
                  dense
                  outlined
                  ref="partnerlogo"
                  class="rounded"
                  accept="image/png, image/jpeg, image/bmp, image/bmp"
                  placeholder="ID Last Page"
                  prepend-icon=""
                  :rules="fileRules"
                >
                  <template v-slot:append>
                    <v-btn depressed x-small icon @click="openIdlast">
                      <v-icon aria-hidden="false" color="primary">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </template>
                  <!-- <template v-slot:append-outer>
                    <v-img
                      v-if="
                        partnerDetails.partner_Logo
                          ? partnerDetails.partner_Logo.value
                          : null
                      "
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                      :src="
                        partnerDetails.partner_Logo
                          ? partnerDetails.partner_Logo.value
                          : null
                      "
                      @click="
                        handleImageViewer(
                          partnerDetails.partner_Logo
                            ? partnerDetails.partner_Logo.value
                            : null
                        )
                      "
                    />
                  </template> -->
                  <!-- <template v-slot:append-outer>
                    <v-img
                      v-if="uploadedImage"
                      :src="uploadedImage"
                      class="mt-0 pa-0"
                      max-height="40"
                      max-width="50"
                    />
                  </template> -->
                </v-file-input>
              </v-col>
              <v-col cols="12" md="12">
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-col>

              <div
                class="col-md-12"
                style="display: flex; justify-content: right; margin-top: 8px"
              >
                <v-btn
                  depressed
                  color="primary"
                  min-width="170px"
                  class="me-5 text-capitalize"
                  @click="onSubmitIndData()"
                >
                  Save
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  outlined
                  min-width="170px"
                  @click="closeIndDialog()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- Personal Applicant Info dialog -->
    <v-dialog persistent v-model="personalDialog" max-width="700">
      <v-card>
        <v-form ref="Perform" v-model="valid">
          <v-toolbar color="secondary" dark flat dense>
            Applicant Info
            <v-spacer></v-spacer>
            <v-btn depressed icon @click="closePersonalDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  User Type
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="User Type"
                  :rules="FieldRequired('User Type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Full Name
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder=" Full Name"
                  :rules="FieldRequired(' Full Name')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Gender
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Gender"
                  :rules="FieldRequired('Gender')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Date of Birth
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="date"
                  :rules="FieldRequired('Date of Birth')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Country Of Birth
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  :rules="FieldRequired('Country')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Nationality
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Nationality"
                  :rules="FieldRequired('Nationality')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Occupation
                </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Occupation"
                  :rules="FieldRequired('Occupation')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  E-mail
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="E-mail"
                  :rules="FieldRequired('E-mail')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="my-0 rounded labelFontsize required">
                  Contact Number
                </label>
                <vue-phone-number-input
                  :default-country-code="company_mobile_cty_code"
                  class=""
                  required
                />
                <small v-if="contact_error2" class="danger"
                  >Contact number is required</small
                >
              </v-col>
              <v-col cols="12" md="12">
                <v-divider class="pa-0 ma-0 mb-2"></v-divider>
              </v-col>

              <div
                class="col-md-12"
                style="display: flex; justify-content: right; margin-top: 8px"
              >
                <v-btn
                  depressed
                  color="primary"
                  min-width="170px"
                  class="me-5 text-capitalize"
                  @click="onSubmitForPersonal()"
                >
                  Save
                </v-btn>

                <v-btn
                  depressed
                  color="primary"
                  class="text-capitalize"
                  outlined
                  min-width="170px"
                  @click="closePersonalDialog()"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Cancel
                </v-btn>
              </div>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
// import axios from "axios";
import alerts from "@/mixins/alerts";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import imageViewer from "@/utils/imageViewer.vue";
import BusDocuments from "./BusDocuments.vue";
import businessService from "@/services/BusinessService/businessService.js";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { FieldRequired } from "@/utils/validation.js";
export default {
  mixins: [alerts],
  data: () => ({
    FieldRequired,
    id_type: "",
    loader: false,
    dialog: false,
    indDialog: false,
    personalDialog: false,
    show: false,
    showindDialog: false,
    showBusDialog: false,
    contact_error2: false,
    company_mobile_cty_code: "MY",
    search: "",
    valid: true,
    currentDate: new Date().toJSON().split("T")[0],
    Entitycheckbox: [],
    validationFields: [],
    fileRules: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    isValidNumber: false,
    NatureOfBusiness: [],
    CountryOptions: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    editedItems: {
      full_name: "",
      country_code: "",
      id_number: "",
      dob: "",
      address: "",
      phone_number: "",
      email_id: "",
      nature_of_business: "",
      share_holding_percentage: 0,
      no_of_shares: 0,
    },
    isSubmitted: false,
    isUploading: false,
    alertMsg: {
      status: false,
      text: "",
      timeout: 2000,
      color: "blue-grey",
      type: "info",
    },
    countrySelected: {},
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "biz_user_id",
      },
      {
        text: "Name/Company",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "ID type", value: "id_type", sortable: false },
      { text: "ID number", value: "id_number", sortable: false },
      { text: "Designation", value: "applicant_type", sortable: false },
      { text: "Nationality", value: "nationality", sortable: false },
      { text: "DOB/DOI", value: "dob", sortable: false },
      { text: "Email", value: "email_id", sortable: false },
      { text: "Contact Number", value: "phone_number", sortable: false },
      { text: "Employer Name", value: "employee_name", sortable: false },
      {
        text: "Shareholding (%)",
        value: "percentage_of_shares",
        sortable: false,
      },
      {
        text: "Nature of Business",
        value: "nature_of_business",
        sortable: false,
      },
      {
        text: "Occupation",
        value: "occupation",
        sortable: false,
      },
      { text: "First page", value: "id_first_page", sortable: false },
      { text: "Last page", value: "id_last_page", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,

    deleteId: "",

    is_shareholder: true,
  }),
  name: "BasicDetails",
  components: {
    VuePhoneNumberInput,
    BusDocuments,
    imageViewer,
    OverlayPageVue,
  },

  mounted() {
    if (this.$route.query.login_id || this.$route.query.id) {
      this.getBusinessInfo();
    }
  },

  methods: {
    handleFileUpload(data) {
      console.log("image data", data);
      if (data) {
        this.editedItem.id_last_page = URL.createObjectURL(data);
      } else {
        this.editedItem.id_last_page = null;
      }
      if (data.type.startsWith("image/")) {
        this.fileRules = [];
      } else {
        this.fileRules.push("Invalid image type.");
      }
    },

    onChangeCompanyNumber(e) {
      console.log(e);
      e ? (this.contact_error2 = false) : (this.contact_error2 = true);
      // this.isValidNumber = e.isValid;
      this.editedItems.phone_number = e;
      this.editedItems.country_code = this.company_mobile_cty_code;
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    openBUSShareHolderDialog() {
      this.dialog = true;
      this.editedItems = {};
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    openIndShareHolderDialog() {
      this.indDialog = true;
      if (this.$refs.IndForm) {
        this.$refs.IndForm.resetValidation();
      }
    },

    editItem(item) {
      // this.personalDialog = true;
      console.log(item);
      // this.editedItems = item;
    },

    closeDialog() {
      this.dialog = false;
      this.contact_error2 = false;
      this.$refs.Addform.resetValidation();
    },
    closeIndDialog() {
      this.indDialog = false;
      this.contact_error2 = false;
      this.$refs.Addform.resetValidation();
    },

    onSubmitFor() {
      !this.editedItems.phone_number
        ? (this.contact_error2 = true)
        : (this.contact_error2 = false);
      const validate = this.$refs.Addform.validate();
      if (validate && this.contact_error2 == false) {
        // this.save();
      }
    },
    onSubmitIndData() {
      !this.editedItems.phone_number
        ? (this.contact_error2 = true)
        : (this.contact_error2 = false);
      const validate = this.$refs.IndForm.validate();
      if (validate && this.contact_error2 == false) {
        // this.save();
      }
    },

    openPersonalDialog() {
      this.personalDialog = true;
      if (this.$refs.Perform) {
        this.$refs.Perform.resetValidation();
      }
    },

    closePersonalDialog() {
      this.personalDialog = false;
      this.contact_error2 = false;
      this.$refs.Perform.resetValidation();
    },

    onSubmitForPersonal() {
      const validate = this.$refs.Perform.validate();
      if (validate) {
        // this.save();
      }
    },

    // async save() {
    //   console.log(this.editedProfile);
    //   this.loader = true;
    //   try {
    //     const responseData = await businessService.updateEntityDetails(
    //       this.editedProfile
    //     );
    //     if (responseData.data.status_code === 200) {
    //       this.showAlertSuccess(responseData.data.message);
    //       this.dialog = false;
    //       this.loader = false;
    //       this.getBusinessInfoData()
    //       console.log("update", responseData);
    //     } else {
    //       this.showAlertError(responseData.data.message);
    //       this.loader = false;
    //     }
    //   } catch (error) {
    //     console.error(error);
    //     this.loader = false;
    //   }
    // },

    async getBusinessInfo() {
      this.loader = true;
      try {
        const response = await businessService.getallApplicantinfo(
          this.$route.query.id
        );
        if (response.data.status_code === 200) {
          this.getinformation = response.data.data.reverse();
          console.log("Authrization Data", response.data);
          this.loader = false;
        } else {
          this.getinformation = [];
          this.loader = false;
        }
      } catch (error) {
        this.getinformation = [];
        console.error(error);
        this.loader = false;
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
.required:after {
  content: " *";
  color: red;
}
.danger {
  color: red;
  transition: 1s;
}
</style>
